import { render, staticRenderFns } from "./WalmartPeopleFlowSlot.vue?vue&type=template&id=4640a46e&scoped=true"
import script from "./WalmartPeopleFlowSlot.vue?vue&type=script&lang=js"
export * from "./WalmartPeopleFlowSlot.vue?vue&type=script&lang=js"
import style0 from "./WalmartPeopleFlowSlot.vue?vue&type=style&index=0&id=4640a46e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4640a46e",
  null
  
)

export default component.exports